var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 480,
    viewBox: "0 0 509 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.397 62.5669H107.06V479.271H395.397V62.5669Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 389.178H198.093V479.271H304.366V389.178Z",
    fill: "#E9EEF3",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.987 28.642H204.483V62.5669H297.987V28.642Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.228 62.5669V388.041",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.841 441.887H238.969",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.721 443.749C232.749 443.749 233.583 442.915 233.583 441.887C233.583 440.859 232.749 440.025 231.721 440.025C230.693 440.025 229.859 440.859 229.859 441.887C229.859 442.915 230.693 443.749 231.721 443.749Z",
    fill: "#F39200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.967 443.749C239.996 443.749 240.829 442.915 240.829 441.887C240.829 440.859 239.996 440.025 238.967 440.025C237.939 440.025 237.105 440.859 237.105 441.887C237.105 442.915 237.939 443.749 238.967 443.749Z",
    fill: "#F39200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.441 441.887H273.569",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.321 443.749C267.349 443.749 268.182 442.915 268.182 441.887C268.182 440.859 267.349 440.025 266.321 440.025C265.292 440.025 264.459 440.859 264.459 441.887C264.459 442.915 265.292 443.749 266.321 443.749Z",
    fill: "#F39200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M273.567 443.749C274.595 443.749 275.429 442.915 275.429 441.887C275.429 440.859 274.595 440.025 273.567 440.025C272.539 440.025 271.705 440.859 271.705 441.887C271.705 442.915 272.539 443.749 273.567 443.749Z",
    fill: "#F39200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.936 134.304H153.421V187.819H206.936V134.304Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346.557 134.304H293.042V187.819H346.557V134.304Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.936 218.333H153.421V271.848H206.936V218.333Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M346.557 218.333H293.042V271.848H346.557V218.333Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.936 302.363H153.421V355.879H206.936V302.363Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M346.557 302.363H293.042V355.879H346.557V302.363Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.228 28.6404V0.317444",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.618164 479.271H508.618",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.8f7a2d14.svg";
export { ForwardRef as ReactComponent };